import React from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import Table from "react-bootstrap/Table";

const Footer = props => {
  return (
    <div
      className="p-1"
      style={{
        marginBottom: "10px",
        marginTop: "10px",
      }}
    >
      <Table>
        <tbody>
          <tr>
            <td>
              <Link
                to={{ pathname: "https://www.mettlenetworks.com/about.html" }}
                target="_blank"
              >
                About US
              </Link>{" "}
              |{" "}
              <small>
                {props.sequence} / {props.timestamp}
              </small>
            </td>
            <td align="right">
              &copy; 2021{" "}
              <Link
                to={{ pathname: "https://www.mettlenetworks.com/" }}
                target="_blank"
              >
                Mettle Networks
              </Link>
            </td>
          </tr>
        </tbody>
      </Table>
    </div>
  );
};

const mapStateToProps = state => {
  return {
    timestamp: state.rmqReducer.agents.timestamp,
    sequence: state.rmqReducer.agents.sequence,
  };
};

export default connect(mapStateToProps, {})(Footer);
